<template>
  <section>
    <b-loading :is-full-page="true" :active.sync="isPageLoading" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      isPageLoading: (state) => state.applicationStore.isPageLoading,
    }),
  },
};
</script>
